<template>
    <ies-form-field :field="field">
        <input type="hidden" :value="field.value" :name="field.fieldName">
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-preset-true',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
        }
    },
	created: function() {
		this.field.value = true;
	}
}
</script>

